(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('CompanyReopenFranchiserController', CompanyReopenFranchiserController)

    /** @ngInject */
    function CompanyReopenFranchiserController($q, $state, LoadingHelper, CompanyService, UtilHelper, NotifyHelper, sweetAlert) {
        const vm = this;
        let allCompanies;

        vm.prepareReopenCompany = () => {
            LoadingHelper.startLoading('.loading-holder');

            $q.all([getCompanies()])
                .then(() => {
                    vm.step = 2;
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        vm.getCompanies = search => {
            if (!search) {
                vm.companies = [];
                return;
            }

            vm.companies = allCompanies.filter(company => filterCompany(company, search))
        }

        vm.reopenCompany = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você está prestes a criar uma nova empresa utilizando o identificador único da empresa selecionada, essas empresas estarão associadas no histórico. Essa ação é irreversível!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.page-content');

                    let companyReopenData = {
                        Id: vm.selectedCompanyToReopen.Id,
                        CorporateName: vm.companyNewData.CorporateName,
                        FantasyName: vm.companyNewData.FantasyName,
                        ExternalCode: vm.companyNewData.ExternalCode,
                        IE: vm.companyNewData.IE,
                        CNPJ: vm.companyNewData.CNPJ
                    }

                    CompanyService
                        .reopenCompany(companyReopenData)
                        .then(success => {
                            $state.go('app.franchiser-companies-edit', {
                                companyId: success.Id
                            });

                            NotifyHelper.success('Empresa reaberta com sucesso');
                            LoadingHelper.stopLoading('.page-content');
                        }, error => {
                            LoadingHelper.stopLoading('.page-content');
                            UtilHelper.errorCallback(error);
                        })
                }
            })
        }

        init();

        function getCompanies() {
            return CompanyService
                .getAllClosedResumed()
                .then(success => {
                    allCompanies = success;
                }, error => {
                    UtilHelper.errorCallback(error);
                })
        }

        function filterCompany(company, search) {
            if (company.FantasyName == null)
                company.FantasyName = '';

            if (company.CorporateName == null)
                company.CorporateName = '';

            if (company.UniqueCode == null)
                company.UniqueCode = '';

            if (company.ExternalCode == null)
                company.ExternalCode = '';

            if (company.FantasyName.toLowerCase().includes(search.toLowerCase()) || company.CorporateName.toLowerCase().includes(search.toLowerCase()) || company.UniqueCode.toString().includes(search) || company.ExternalCode.toString().includes(search))
                return company;
        }

        function init() {
            vm.step = 1;
            vm.selectedType;
        }
    }
}());